// extracted by mini-css-extract-plugin
module.exports = {"Card":"IntroVideoAppVideo_Card__14hye","Video":"IntroVideoAppVideo_Video__14ey3"};